export const LOGO_IMG_URL = "https://res.cloudinary.com/drdgj0pch/image/upload/v1710779644/pngwing.com_vzlpd9.png";

export const RATING_STAR_ICON_URL = "https://res.cloudinary.com/drdgj0pch/image/upload/v1710400102/Frontend/Icons/star_rating_twbpwj.svg";

export const SWIGGY_MEDIA_ASSEST = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";

export const RESTAURANT_LIST_API = "/dapi/restaurants/list/v5?lat=17.406498&lng=78.47724389999999";

export const MENU_API = "/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.0240649&lng=72.60021069999999&restaurantId=";

// Helper function to handle local development CORS proxy vs Netlify production proxy
export const getApiUrl = (endpoint) => {
  const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";
  if (isLocalhost) {
    return "https://corsproxy.io/?key=51132fd5&url=" + encodeURIComponent("https://www.swiggy.com" + endpoint);
  }
  return endpoint;
}; 